import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { trackPhoneCall } from "@/lib/googleAds";

/**
 * StickyCallButton — full-width lime green bar pinned to the bottom of the screen on mobile only.
 * Appears after the user scrolls past the hero section (80% of the initial viewport height).
 * Slides in smoothly and respects iOS safe-area-inset-bottom.
 */
export default function StickyCallButton() {
  const [isMobile, setIsMobile] = useState(false);
  const [pastHero, setPastHero] = useState(false);

  useEffect(() => {
    // Detect mobile viewport
    const mq = window.matchMedia("(max-width: 767px)");
    const updateMobile = (e: MediaQueryListEvent | MediaQueryList) =>
      setIsMobile(e.matches);
    updateMobile(mq);
    mq.addEventListener("change", updateMobile as (e: MediaQueryListEvent) => void);

    // Show bar after scrolling past ~80% of the initial viewport height (past the hero)
    const threshold = window.innerHeight * 0.8;
    const onScroll = () => setPastHero(window.scrollY > threshold);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // run once on mount

    return () => {
      mq.removeEventListener("change", updateMobile as (e: MediaQueryListEvent) => void);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  // Don't render on desktop at all
  if (!isMobile) return null;

  const handleCall = () => {
    trackPhoneCall();
    window.location.href = "tel:8054038727";
  };

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9998,
        paddingBottom: "env(safe-area-inset-bottom)",
        transform: pastHero ? "translateY(0)" : "translateY(100%)",
        transition: "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
        willChange: "transform",
      }}
    >
      <button
        onClick={handleCall}
        aria-label="Call Danis Painting Co. at 805-403-8727"
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          backgroundColor: "#4caf30",
          color: "#ffffff",
          fontWeight: "700",
          fontSize: "16px",
          padding: "16px 24px",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 -4px 16px rgba(0,0,0,0.18)",
        }}
      >
        <Phone style={{ width: 20, height: 20, flexShrink: 0 }} />
        <span>Call Now — 805-403-8727</span>
      </button>
    </div>
  );
}
